// src/config.js

const API_BASE_URL = 'https://api.umbrellaco.in';
const APP_DOMAIN = 'umbrellaco.in';

const config = {
    API_BASE_URL,
    APP_DOMAIN,
};

export default config;
